module.exports = __webpack_public_path__ + "img/introduceImg.116a754a.png";